import { useWebsiteSettings } from 'client/store/index'
import { getWebsitePageReplacement } from 'common/utils/website-replacements-utils'
import React, { useMemo } from 'react'
import { websitePagesQuery } from 'src/editor/api/queries/website-pages-query'
import {
  OptionSingleValueType,
  OptionType,
  SelectNew,
} from 'src/editor/shared/ui-lib/select-new/select-new'
import {
  getCurrentWebsiteLocale,
  getWebsiteId,
} from 'src/editor/store/website-settings/website-settings-selector'

interface WebsiteLinkProps {
  update: (val: string) => void
  link: string | null
  className?: string
  withoutWrapper?: boolean
  labelText?: string
}

export const WebsiteLink = ({
  update,
  link,
  className,
  withoutWrapper = true,
  labelText,
}: WebsiteLinkProps) => {
  const currentWebsiteLocale = useWebsiteSettings(getCurrentWebsiteLocale)
  const websiteId = useWebsiteSettings(getWebsiteId) as number

  const { data, isFetching } = websitePagesQuery.useQuery({
    queryFnArgs: [websiteId],
  })

  const options = useMemo(() => {
    return (
      data?.pages.reduce((acc, websitePageSet) => {
        const websitePage = websitePageSet.locales.find(
          ({ locale }) => locale === currentWebsiteLocale,
        )
        if (websitePage) {
          acc.push({
            value: getWebsitePageReplacement(websitePage.pageContentId),
            label: websitePage.name,
          })
        }
        return acc
      }, [] as OptionType[]) || []
    )
  }, [data, currentWebsiteLocale])

  const onChangeOption = (option: OptionSingleValueType) => {
    if (option) {
      update(option.value)
    }
  }

  const selectedOption = useMemo(() => {
    return options.find(option => option.value === link) || null
  }, [options, link])

  return (
    <SelectNew
      className={className}
      isLoading={isFetching}
      withoutWrapper={withoutWrapper}
      onChange={onChangeOption}
      options={options}
      selectedOption={selectedOption}
      labelText={labelText}
    />
  )
}
